import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GeneralMatPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();
    const rangeLabel = (page: number, pageSize: number, length: number) => {
      const of = $localize`of`;
      if (length === 0 || pageSize === 0) {
        return `0 ${of} ${length}`;
      }

      length = Math.max(length, 0);

      const startIndex = page * pageSize;

      // If the start index exceeds the list length, do not try and fix the end index to the end.
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} ${of} ${length}`;
    };
    this.itemsPerPageLabel = $localize`Items per page:`;
    this.nextPageLabel = $localize`Next page`;
    this.previousPageLabel = $localize`Previous page`;
    this.lastPageLabel = $localize`Last page`;
    this.firstPageLabel = $localize`First page`;
    this.getRangeLabel = rangeLabel;
  }
}
